import { useEffect, useState } from "react";
import Eligibility from "./Eligibility";
import Timeline from "./Timeline";
import SectionFaq from "./SectionFaq";
import Tabs from "../../../elements/Tabs";
import { useBanner } from "../../../../providers/BannerProviders";
import SectionTable from "./SectionTable";
import useFetch from "../../../../hooks/useFetch";
import { scholarshipList } from "../../../../services/scholarshipService";
import dayjs from "dayjs";
import { checkDateStatus, removeDuplicateFromArray } from "../../../../helpers";
import Modal from "../../../elements/Modal";
import EligibilityQuizContent from "../../../modalcontent/EligibilityQuizContent";
import ApplicationDetails from "../../../modalcontent/ApplicationDetails";
import ApplicationModalFront from "./modals/ApplicationModalFront";
import { useSelector } from "react-redux";
import ApplicationNotOpenInfoModal from "./modals/ApplicationNotOpenInfoModal";

const SectionApply = () => {
  const { data } = useBanner();
  const { session } = useSelector((state) => state?.authProvider);
  const [notOpenQuizModal, setNotOpenQuizModal] = useState({
    isOpen: false,
    data: null,
  });
  const [isViewDetails, setViewDetails] = useState({
    isOpen: false,
    data: null,
  });
  const [action, setAction] = useState(false);
  const [applicationModal, setApplicationModal] = useState({
    isOpen: false,
    data: null,
  });
  const [isApply, setApply] = useState({ isOpen: false, data: null });
  const applyBanner = data?.data?.find((item) => item?.bannerType === "apply");
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
  });
  const [allScholarships, setAllScholarships] = useState({ data: [] });

  const tabs = [
    {
      _id: 1,
      name: applyBanner?.details?.eligibility?.title,
      component: <Eligibility />,
    },
    {
      _id: 2,
      name: applyBanner?.details?.timeline?.title,
      component: <Timeline />,
    },
    {
      _id: 3,
      name: applyBanner?.details?.faq?.title,
      component: <SectionFaq />,
    },
  ];

  const {
    data: scholarshipData,
    isLoading: timelineLoading,
    refetch,
  } = useFetch({
    dependencies: ["font-scholarship-timeline", filters],
    fetchFunction: async () => {
      const res = await scholarshipList({
        status: 1,
        ...filters,
        scholarship: "front",
      });
      return res?.docs || [];
    },
  });

  useEffect(() => {
    if (scholarshipData?.data?.length) {
      setAllScholarships((prev) => ({
        ...scholarshipData,
        data: removeDuplicateFromArray([
          ...prev.data,
          ...scholarshipData?.data,
        ]),
      }));
    }
  }, [scholarshipData]);

  const getApplyButtonProps = (item) => {
    const {
      isQualified,
      publishEndDate,
      isStartedApplying,
      publishDate,
      statusDetails,
    } = item;

    const isPast = checkDateStatus(publishEndDate) === "past";
    const isUpcoming = checkDateStatus(publishDate) === "upcoming";

    if (isUpcoming) {
      return {
        label: "Opening Soon",
        onClick: () => setNotOpenQuizModal({ data: item, isOpen: true }),
      };
    }

    if (isQualified) {
      if (isPast && isStartedApplying === "notStarted") {
        return { label: "Currently Unavailable" };
      }
      if (statusDetails?.title === "Draft") {
        return {
          label: "Incomplete/Draft",
          onClick: () => setApply({ isOpen: true, data: item }),
        };
      }

      switch (isStartedApplying) {
        case "completed":
          return { label: "Applied" };
        case "ongoing":
          return {
            label: "Incomplete/Draft",
            onClick: () => setApply({ isOpen: true, data: item }),
          };
        case "notStarted":
          return {
            label: "Apply",
            onClick: () => setApply({ isOpen: true, data: item }),
          };
        default:
          return { label: "Currently Unavailable" };
      }
    } else {
      if (isStartedApplying === "completed") {
        return { label: "Applied" };
      }

      return {
        label: isStartedApplying === "ongoing" ? "Incomplete/Draft" : "Apply",
        onClick: () => setApply({ isOpen: true, data: item }),
      };
    }
  };

  const tableData = [
    {
      _id: 1,
      title: "Available Opportunities",
      subdata: allScholarships?.data?.map((item) => {
        return {
          ...item,
          date: item?.publishEndDate
            ? dayjs(item?.publishEndDate).format("MMMM DD, YYYY")
            : "Ongoing",
          viewAction: {
            label:
              getApplyButtonProps(item).label === "Apply"
                ? "View Details"
                : "View Soon",
            isLink: false,
            onClick:
              getApplyButtonProps(item).label === "Apply"
                ? () => setViewDetails({ isOpen: true, data: item })
                : null,
          },
          applyAction: {
            isLink: false,
            ...getApplyButtonProps(item),
          },
        };
      }),
    },
  ];

  useEffect(() => {
    if (action) {
      refetch();
    }
  }, [action]);
  return (
    <>
      <section className="relative flex w-full pt-16 pb-0 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="space-y-10 sm:space-y-16">
            {tableData?.length > 0 && (
              <div className="">
                {tableData?.map((item, index) => (
                  <SectionTable
                    key={index}
                    data={item}
                    timelineLoading={timelineLoading}
                    scholarshipData={scholarshipData}
                    setFilters={setFilters}
                  />
                ))}
              </div>
            )}

            <div className="relative text-center space-y-10 max-w-6xl mx-auto">
              <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold">
                {applyBanner?.contentTitle}
              </h2>
              <div
                className="text-base xls:text-lg xls:font-medium font-Gotham space-y-3"
                dangerouslySetInnerHTML={{
                  __html: applyBanner?.contentDescription,
                }}
              />
            </div>
            <div className="relative w-full">
              <Tabs
                tabs={tabs}
                tabContainerClass={"!items-center"}
                tabNavClass={
                  "justify-start xls:justify-center !gap-4 xls:!gap-8"
                }
                tabButtonClass={
                  "!h-12 xls:!h-14 !rounded-full min-w-48 xls:min-w-60 !border border-chestnut-rose !bg-white !text-chestnut-rose !text-base md:!text-lg"
                }
                tabButtonActiveClass={"!bg-chestnut-rose !text-white"}
              />
            </div>
          </div>
        </div>
        <Modal
          isOpen={isApply?.isOpen}
          setIsOpen={() => {
            setApply({ isOpen: false, data: null });
          }}
          title={
            session?.status === "unauthorized"
              ? "Sign In Required to Apply"
              : "Eligibility Quiz"
          }
          size="lg"
          bodyClasses={"!pb-10"}
        >
          <EligibilityQuizContent
            data={isApply?.data}
            okHandler={() => setApply({ isOpen: false, data: null })}
            setApplicationModal={setApplicationModal}
            setAction={setAction}
          />
        </Modal>
        <Modal
          isOpen={isViewDetails?.isOpen}
          setIsOpen={() => setViewDetails({ isOpen: false, data: null })}
          title={isViewDetails?.data?.title || ""}
          size="xl5"
          bodyClasses={"px-8 md:px-10"}
          titleClass={"!text-base"}
        >
          <ApplicationDetails
            data={isViewDetails?.data}
            onApply={(data) => {
              setApply({ isOpen: true, data: data });
              setViewDetails({ isOpen: false, data: null });
            }}
            close={() => setViewDetails({ isOpen: false, data: null })}
          />
        </Modal>
        <ApplicationNotOpenInfoModal
          isOpen={notOpenQuizModal?.isOpen}
          close={() => {
            setNotOpenQuizModal({ isOpen: false, data: null });
          }}
          data={notOpenQuizModal?.data}
        />
        {applicationModal.isOpen && (
          <ApplicationModalFront
            open={applicationModal?.isOpen}
            close={() => {
              setApplicationModal({ isOpen: false, data: null });
              setAction(true);
            }}
            details={applicationModal.data}
          />
        )}
      </section>
    </>
  );
};

export default SectionApply;
